// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__i6tGS","content":"LayoutSettings_content__1lg29"};